export default function FunctionsController() {
  const vm = this;

  vm.handleDeletedFunction = _handleDeletedFunction;


  /** ******************************************
   * Event Handlers
   *
   */

  function _handleDeletedFunction(functionObj) {
    if (!functionObj) return;
    const pos = vm.functions.indexOf(functionObj);
    if (pos === -1) return; // Can't find the item
    vm.functions.splice(pos, 1);
  }

  /** ******************************************
   * Private Functions
   *
   */
}

FunctionsController.$inject = [];
